import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { VisualGuideManagerService } from './visual-guide-manager.service';

@Directive({
    selector: '[libVisualGuideInitiator]',
    standalone: false
})
export class VisualGuideInitiatorDirective implements OnChanges, OnDestroy {
  @Input() libVisualGuideInitiator: string;
  @Input() visualGuideAutoStart = true;
  @Input() visualGuideRoot?: HTMLElement;
  @Output() readonly visualGuideStarting = new EventEmitter<void>();
  private readonly destroyed$ = new Subject<void>();
  private registeredContainer: string;
  private registeredAutoStart: boolean;
  private registeredNode: HTMLElement;

  constructor(
    private readonly visualGuideService: VisualGuideManagerService,
    private readonly elementRef: ElementRef<HTMLElement>,
  ) {
    visualGuideService.guideStarting$
      .pipe(
        filter(
          ({ visualGuideId, node }) =>
            visualGuideId === this.registeredContainer &&
            node === this.registeredNode,
        ),
        takeUntil(this.destroyed$),
      )
      .subscribe(() => this.visualGuideStarting.emit());
  }

  ngOnChanges(): void {
    const node = this.visualGuideRoot || this.elementRef.nativeElement;
    if (
      this.registeredContainer === this.libVisualGuideInitiator &&
      this.registeredAutoStart === this.visualGuideAutoStart &&
      this.registeredNode === node
    )
      return;
    if (
      this.registeredContainer !== this.libVisualGuideInitiator ||
      this.registeredNode !== node
    )
      this.unregister();
    this.registeredContainer = this.libVisualGuideInitiator;
    this.registeredAutoStart = this.visualGuideAutoStart;
    this.registeredNode = node;
    if (this.registeredContainer)
      this.visualGuideService.checkForGuide(
        this.registeredContainer,
        this.registeredNode,
        this.registeredAutoStart,
      );
  }

  ngOnDestroy(): void {
    this.destroyed$.next(undefined);
    this.destroyed$.complete();
    this.unregister();
  }

  private unregister(): void {
    if (this.registeredContainer)
      this.visualGuideService.removeGuide(
        this.registeredContainer,
        this.registeredNode,
      );
    this.registeredContainer = undefined;
    this.registeredNode = undefined;
  }
}
